<template>
  <div class="">
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>

    <template v-if="packageData">
      <!-- Oferta aktywna: współdzielony formularz płatności -->
      <div v-if="packageData.active" class="special-offer-form">
        <PaymentForm
          :profile="profile"
          :submitAction="'payment/createSpecialOfferOrder'"
          :submitParams="{
            specialOfferId: $route.params.id,
            type:
              packageData && packageData.type ? packageData.type : 'STANDARD',
          }"
        />
      </div>

      <!-- Oferta nieaktywna -->
      <v-container v-else class="container mt-10" fluid>
        <v-row justify="center" align="baseline">
          <v-col cols="12" sm="6" md="4" lg="4" xl="3">
            <v-card shaped elevation="5" class="card">
              <v-container class="py-10 px-10 text-center">
                <p style="color: #8b857d; margin-bottom: 40px;">
                  Zajęcia obecnie są nieaktywne. Spróbuj ponownie bliżej ich
                  rozpoczęcia.
                </p>
                <a
                  href="https://dagajoga.pl/index.php/zajecia-na-zywo/"
                  class="primary-button"
                  >OK</a
                >
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Oferta specjalna niedostępna -->
    <v-container v-else class="container mt-10" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container class="mb-12">
              <h3 class="text-center" style="padding: 1rem">
                Przepraszamy, ta oferta specjalna nie jest już dostępna
              </h3>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaymentForm from "../components/forms/PaymentForm.vue";
export default {
  metaInfo: {
    title: "Dagajoga oferta specjalna - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "SpecialOfferPayment",
  components: {
    PaymentForm,
  },
  computed: {
    packageData: function() {
      return this.$store.getters["specialOffers/getSpecialOffer"];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  async created() {
    this.$store.commit("payment/SET_INIT_VALUES");
    await this.$store.dispatch(
      "specialOffers/fetchSpecialOffer",
      this.$route.params.id
    );
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");
    const token = window.localStorage.getItem("userToken");
    if (!token) {
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Zakup oferty specjalnej dostępny jest wyłącznie dla zalogowanych użytkowników",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      this.$router.push({
        name: "Auth",
        params: {
          previousPath: `/warsztaty-z-sekwencjonowania/platnosc/${this.$route.params.id}`,
        },
      });
    }
  },
  destroyed() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
};
</script>

<style scoped>
.container {
}
.special-offer-form {
  max-width: 640px;
  margin: 0 auto;
  padding: 30px;
}
.card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
.ok-button {
  width: 150px;
  height: 2rem;
  text-decoration: none;
  color: #fff;
  display: block;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ok-button:hover {
  transform: none;
}
</style>
